import { CertificateRecordStatusEnum } from '../enums/certificate-record-status.enum';

export class CertificateRecordStatus {
    static all: { translationLabel: string; value: number }[] = [
        {
            translationLabel: 'PAGE.CERTIFICATIONS.LABEL.VALID',
            value: CertificateRecordStatusEnum.Valid,
        },
        {
            translationLabel: 'PAGE.CERTIFICATIONS.LABEL.REPLACED',
            value: CertificateRecordStatusEnum.Replaced,
        },
        {
            translationLabel: 'PAGE.CERTIFICATIONS.LABEL.EXPIRED',
            value: CertificateRecordStatusEnum.Expired,
        },
    ];
}
